export class PerDiemDocumentType {
  name: string;
  readOnly: boolean;
  canUpdateMetadata: boolean;
  canUploadContent: boolean;
  attachmentTypeID: number;
}
